import { render } from "./SettingsTemplate.vue?vue&type=template&id=a1a52712&scoped=true"
import script from "./SettingsTemplate.vue?vue&type=script&lang=js"
export * from "./SettingsTemplate.vue?vue&type=script&lang=js"

import "./SettingsTemplate.vue?vue&type=style&index=0&id=a1a52712&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-a1a52712"

export default script